<template>
  <div class="v2026-aifc-bk">

    <div class="v2026-ai-card v2026-aifc-bk__card" role="status" aria-live="polite">
      <div class="v2026-aifc__result-title">ข้อมูลการจองที่ AI วิเคราะห์ได้</div>

      <div class="v2026-aifc__kv" v-if="serviceName">
        <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
              :style="maskStyle(icons.document)"></span>
        <span class="v2026-aifc__kv-label">บริการ</span>
        <span class="v2026-aifc__kv-value">{{ serviceName }}</span>
      </div>

      <div class="v2026-aifc__kv" v-if="form.work_hour">
        <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
              :style="maskStyle(icons.time)"></span>
        <span class="v2026-aifc__kv-label">จำนวนชม.</span>
        <span class="v2026-aifc__kv-value">{{ form.work_hour }} ชม.</span>
      </div>

      <div class="v2026-aifc__kv" v-if="serviceDates.length || singleDate">
        <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
              :style="maskStyle(icons.calendar)"></span>
        <span class="v2026-aifc__kv-label">วันที่</span>
        <span class="v2026-aifc__kv-value">
          <template v-if="serviceDates.length">
            <span>{{ serviceDates.length }} วัน</span>
            <span class="v2026-aifc__kv-line" v-for="(serviceDate, index) in serviceDates" :key="index">
              – {{ serviceDate | prettyOnlyDate }}
              <span v-if="showTime">{{ form.service_time }}</span>
            </span>
          </template>
          <template v-else>
            <span>{{ singleDate | prettyOnlyDate }}</span>
            <span v-if="showTime">&nbsp;{{ form.service_time }}</span>
          </template>
        </span>
      </div>

      <div class="v2026-aifc__kv" v-if="usedProfessional">
        <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
              :style="maskStyle(icons.user)"></span>
        <span class="v2026-aifc__kv-label">แม่บ้านเดิม</span>
        <span class="v2026-aifc__kv-value">{{ usedProfessionalText }}</span>
      </div>

      <template v-if="preBookings.length">
        <div class="v2026-aifc__meta">ลูกค้ามีรายการ Pre-Booking</div>
        <div class="v2026-aifc__linkchips">
          <a class="v2026-aifc__linkchip" v-for="(preBooking, index) in preBookings" :key="index"
             :href="preBookingUrl(preBooking.id)" :title="preBookingUrl(preBooking.id)"
             target="_blank" rel="noopener noreferrer">
            <span>PB #{{ preBooking.id }}</span>
            <span class="v2026-ai-mask v2026-aifc__link-ico" aria-hidden="true"
                  :style="maskStyle(icons.externalLink)"></span>
          </a>
        </div>
      </template>
    </div>

    <div class="v2026-aifc__form-label">ข้อมูลที่ยังขาด</div>

    <div class="v2026-aifc-bk__form">

      <div class="v2026-aifc__field v2026-aifc-bk__grid" v-if="canSelectTime">
        <div class="v2026-aifc__field">
          <label class="v2026-aifc__label" :for="timeId">เวลา</label>
          <select :id="timeId" class="v2026-aifc__select" v-model="form.service_time">
            <option :value="null">เลือกเวลา</option>
            <option v-for="(time, index) in strTimes" :key="index" :value="time">{{ time }}</option>
          </select>
        </div>
      </div>

      <div class="v2026-aifc__field" v-if="hasUserPlaces">
        <label class="v2026-aifc__label" :for="placeId">สถานที่</label>
        <select :id="placeId" class="v2026-aifc__select" v-model="selectedUserPlace">
          <option :value="null">เลือกที่พัก</option>
          <option v-for="(userPlace, index) in userPlaces" :key="index" :value="userPlace">
            {{ userPlace.place_name }}
          </option>
        </select>
        <div class="v2026-aifc-bk__address" v-if="selectedUserPlace">
          <div class="v2026-aifc-bk__address-row" v-if="selectedUserPlace.address">
            <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
                  :style="maskStyle(icons.location)"></span>
            <span>{{ selectedUserPlace.address }}</span>
          </div>
          <div class="v2026-aifc-bk__address-row" v-if="placeSizeName">
            <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
                  :style="maskStyle(icons.document)"></span>
            <span>{{ placeSizeName }}</span>
          </div>
          <div class="v2026-aifc-bk__address-row" v-if="placeProvinceName">
            <span class="v2026-ai-mask v2026-aifc__kv-ico" aria-hidden="true"
                  :style="maskStyle(icons.mapLocation)"></span>
            <span>{{ placeProvinceName }}</span>
          </div>
        </div>
      </div>

      <div class="v2026-aifc__field" v-else>
        <span class="v2026-aifc__label">สถานที่</span>
        <div class="v2026-aifc__notice">
          <div class="v2026-aifc__notice-title">⚠ ลูกค้ายังไม่มีที่พักในระบบ</div>
          <div class="v2026-aifc__meta">เพิ่มที่พักก่อนจึงจะสร้างรายการจองได้</div>
          <a class="v2026-aifc__link" v-if="customerProfileUrl"
             :href="customerProfileUrl" :title="customerProfileUrl"
             target="_blank" rel="noopener noreferrer">
            <span>เปิดโปรไฟล์ลูกค้า</span>
            <span class="v2026-ai-mask v2026-aifc__link-ico" aria-hidden="true"
                  :style="maskStyle(icons.externalLink)"></span>
          </a>
        </div>
      </div>

      <div class="v2026-aifc__field" v-if="childServices.length">
        <label class="v2026-aifc__label" :for="childServiceId">บริการ</label>
        <select :id="childServiceId" class="v2026-aifc__select" v-model="selectedChildService">
          <option :value="null">เลือกประเภทบริการ</option>
          <option v-for="(childService, index) in childServices" :key="index" :value="childService">
            {{ childServiceLabel(childService) }}
          </option>
        </select>
      </div>

      <div class="v2026-aifc__field">
        <span class="v2026-aifc__label" :id="maidLabelId">แม่บ้าน</span>
        <v-select class="v2026-aifc__maidpick"
                  :options="professionals"
                  :filterable="false"
                  label="full_name"
                  placeholder="ไม่ระบุผู้ให้บริการ"
                  :aria-labelledby="maidLabelId"
                  v-model="selectedProfessional"
                  @search="onSearchProfessionals">
          <template slot="no-options">พิมพ์รหัสหรือชื่อคุณแม่บ้าน</template>
          <template slot="option" slot-scope="option">
            <span class="v2026-aifc__maidpick-id">ID:{{ option.id }}</span>
            <span class="v2026-aifc__maidpick-name" :title="option.full_name">{{ option.full_name }}</span>
          </template>
          <template slot="selected-option" slot-scope="option">
            <span class="v2026-aifc__maidpick-id">ID:{{ option.id }}</span>
            <span class="v2026-aifc__maidpick-name" :title="option.full_name">{{ option.full_name }}</span>
          </template>
        </v-select>
      </div>

    </div>

    <button type="button" class="v2026-aifc__cta" v-if="canBookService" @click="submitData">
      <span class="v2026-ai-mask v2026-aifc__cta-ico" aria-hidden="true"
            :style="maskStyle(icons.createBooking)"></span>
      <span>สร้างรายการจอง</span>
    </button>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

// The tab pane is v-if, so a tab switch destroys this component. One module-level slot keyed on
// the fcResult object identity keeps the operator's half-filled selects; gone on reload.
const FORM_CACHE = { result: null, state: null }

// The '21:00' → '22:30' gap is existing behaviour, not a typo.
const STR_TIMES = [
  '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
  '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '22:30', '23:00', '23:30'
]

export default {
  name: 'booking-result-v2026',
  props: {
    // vuex state (aiAssistant.fcResult) — read-only; every edit goes into `form` instead.
    result: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icons: {
        document: require('@/assets/icons2026/document.svg'),
        time: require('@/assets/icons2026/b-time.svg'),
        calendar: require('@/assets/icons2026/b-calendar.svg'),
        location: require('@/assets/icons2026/b-location.svg'),
        mapLocation: require('@/assets/icons2026/b-maps-location.svg'),
        user: require('@/assets/icons2026/user.svg'),
        externalLink: require('@/assets/icons2026/external-link.svg'),
        createBooking: require('@/assets/icons2026/create-booking.svg')
      },
      strTimes: STR_TIMES,
      // Working copy of result.params; the hand-off query string is built from this, never the prop.
      form: {},
      canSelectTime: false,
      selectedUserPlace: null,
      selectedProfessional: null,
      selectedChildService: null
    }
  },
  computed: {
    ...mapState('conversation', ['customer']),
    ...mapState('professional', ['professionals']),
    timeId () {
      return `v2026-aifc-time-${this._uid}`
    },
    placeId () {
      return `v2026-aifc-place-${this._uid}`
    },
    childServiceId () {
      return `v2026-aifc-childservice-${this._uid}`
    },
    maidLabelId () {
      return `v2026-aifc-maid-${this._uid}`
    },
    params () {
      return (this.result && this.result.params) || {}
    },
    serviceName () {
      return (this.result && this.result.service && this.result.service.name_th) || null
    },
    serviceDates () {
      const list = this.params.service_dates
      return Array.isArray(list) ? list : []
    },
    singleDate () {
      return this.params.service_date || null
    },
    // '00:00:00' is the "no time given" placeholder, not a real midnight.
    showTime () {
      return !!(this.form.service_time && this.form.service_time !== '00:00:00')
    },
    usedProfessional () {
      return (this.result && this.result.professional) || null
    },
    usedProfessionalText () {
      const pro = this.usedProfessional || {}
      return `ID ${pro.id} ${pro.firstname || ''} ${pro.lastname || ''}`.trim()
    },
    preBookings () {
      const list = this.result && this.result.pre_bookings
      return Array.isArray(list) ? list : []
    },
    userPlaces () {
      const list = this.result && this.result.user_places
      return Array.isArray(list) ? list : []
    },
    hasUserPlaces () {
      return this.userPlaces.length > 0
    },
    childServices () {
      const list = this.result && this.result.child_services
      return Array.isArray(list) ? list : []
    },
    placeSizeName () {
      const place = this.selectedUserPlace
      return (place && place.place_size && place.place_size.name_th) || null
    },
    placeProvinceName () {
      const place = this.selectedUserPlace
      return (place && place.province && place.province.name_th) || null
    },
    customerId () {
      return (this.customer && this.customer.customer) ? this.customer.customer.id : null
    },
    customerProfileUrl () {
      return this.customerId ? `https://admin-test.beneat.co/user/${this.customerId}` : null
    },
    canBookService () {
      return this.hasUserPlaces
    }
  },
  watch: {
    selectedChildService () {
      if (this.selectedChildService) {
        this.$set(this.form, 'service_id', this.selectedChildService.id)
        if (this.selectedChildService.duration) {
          this.$set(this.form, 'work_hour', this.selectedChildService.duration)
        }
      }
    }
  },
  created () {
    // Without this the maid picker opens pre-populated with whatever the schedule tab searched
    // for last.
    this.$store.commit('professional/SET_PROFESSIONALS', [])
    if (FORM_CACHE.result === this.result && FORM_CACHE.state) {
      Object.assign(this, FORM_CACHE.state)
      return
    }
    const params = Object.assign({}, this.params)
    if (!params.service_time || params.service_time === '00:00:00') {
      this.canSelectTime = true
      params.service_time = null
    }
    this.form = params
    FORM_CACHE.result = this.result
    FORM_CACHE.state = null
  },
  beforeDestroy () {
    if (FORM_CACHE.result !== this.result) return
    FORM_CACHE.state = {
      form: this.form,
      canSelectTime: this.canSelectTime,
      selectedUserPlace: this.selectedUserPlace,
      selectedProfessional: this.selectedProfessional,
      selectedChildService: this.selectedChildService
    }
  },
  methods: {
    ...mapActions('professional', ['searchProfessionals']),
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    },
    preBookingUrl (id) {
      return `https://admin-test.beneat.co/pre-bookings?id=${id}`
    },
    childServiceLabel (childService) {
      const province = childService.province ? ` ${childService.province.name_th}` : ''
      return `${childService.name_th}${province}`
    },
    objectToQueryString (obj) {
      const params = new URLSearchParams()
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          params.append(key, obj[key])
        }
      }
      return params.toString()
    },
    // On a dev build the hand-off opens localhost:8090 — expected, not a bug.
    submitData () {
      const params = Object.assign({}, this.form)
      params.auto_fill = 1
      if (this.customer) {
        const objCustomer = this.customer.customer
        if (objCustomer) {
          params.user_id = objCustomer.id
          params.email = objCustomer.email
        }
      }
      if (this.selectedUserPlace) {
        params.user_place_id = this.selectedUserPlace.id
      }
      if (this.selectedProfessional) {
        params.selected_professional_id = this.selectedProfessional.id
      }
      const queryParams = this.objectToQueryString(params)
      let url = `https://admin-test.beneat.co/order/create-multiple?${queryParams}`
      if (process.env.NODE_ENV !== 'production') {
        url = `http://localhost:8090/order/create-multiple?${queryParams}`
      }
      const opened = window.open(url, '_blank')
      this.$store.commit('aiAssistant/SET_FC_NOTICE', { kind: opened ? 'opened' : 'popup_blocked' })
    },
    async onSearchProfessionals (search, loading) {
      loading(true)
      if (!search.trim()) {
        loading(false)
      }
      await this.searchProfessionals(search)
      loading(false)
    }
  }
}
</script>

<style scoped>
.v2026-ai-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}
.v2026-ai-card {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
}

.v2026-aifc-bk {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-3);
}

.v2026-aifc-bk__card {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: var(--v2026-sp-3) var(--v2026-sp-4);
}
.v2026-aifc__result-title {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
}

.v2026-aifc__kv {
  display: flex;
  align-items: flex-start;
  gap: var(--v2026-sp-2);
  font-size: var(--v2026-fs-body);
  line-height: 1.5;
}
.v2026-aifc__kv-ico {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  margin-top: 4px;
}
.v2026-aifc__kv-label {
  flex: 0 0 84px;
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
  padding-top: 2px;
}
.v2026-aifc__kv-value {
  flex: 1 1 auto;
  min-width: 0;
  color: var(--v2026-text);
  word-break: break-word;
}
.v2026-aifc__kv-line {
  display: block;
}

.v2026-aifc__meta {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
  line-height: 1.5;
  word-break: break-word;
}

.v2026-aifc__linkchips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--v2026-sp-2);
}
.v2026-aifc__linkchip {
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-1);
  padding: var(--v2026-sp-1) var(--v2026-sp-2);
  border: 1px solid var(--v2026-border);
  border-radius: var(--v2026-r-tab);
  background: var(--v2026-surface);
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-link);
}
.v2026-aifc__linkchip:hover {
  text-decoration: underline;
}
.v2026-aifc__linkchip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}

.v2026-aifc__link {
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  font-size: var(--v2026-fs-body);
  color: var(--v2026-link);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-aifc__link:hover {
  text-decoration: underline;
}
.v2026-aifc__link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
  border-radius: 4px;
}
.v2026-aifc__link-ico {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  background-color: currentColor;
}

.v2026-aifc__form-label {
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}

.v2026-aifc-bk__form {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-3);
}
/* Responds to the column resizer, not the viewport — the rail is user-resizable. */
.v2026-aifc-bk__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--v2026-sp-3);
}

.v2026-aifc__field {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  min-width: 0;
}
.v2026-aifc__label {
  margin: 0;
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}
.v2026-aifc__select {
  width: 100%;
  height: 44px;
  padding: 0 var(--v2026-sp-3);
  border: 1px solid #EBEDF0;
  border-radius: 8px;
  background: var(--v2026-surface);
  font-size: var(--v2026-fs-body);
  color: var(--v2026-text);
}
.v2026-aifc__select:focus {
  outline: none;
  border-color: var(--v2026-color-main);
}

.v2026-aifc-bk__address {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-1);
  padding: var(--v2026-sp-3);
  border: 1px solid var(--v2026-border);
  border-radius: var(--v2026-r-card);
  background: var(--v2026-surface);
}
.v2026-aifc-bk__address-row {
  display: flex;
  align-items: flex-start;
  gap: var(--v2026-sp-2);
  font-size: var(--v2026-fs-body);
  color: var(--v2026-text-secondary);
  line-height: 1.5;
  word-break: break-word;
}

.v2026-aifc__notice {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-1);
  padding: var(--v2026-sp-3);
  border: 1px solid var(--v2026-border);
  border-radius: var(--v2026-r-card);
  background: var(--v2026-surface);
}
.v2026-aifc__notice-title {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text-secondary);
  line-height: 1.5;
}

.v2026-aifc__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--v2026-sp-2);
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  background: linear-gradient(135deg, #2f6bff 0%, #7c3aed 100%);
  color: #ffffff;
  font-size: var(--v2026-fs-body);
  font-weight: 600;
}
.v2026-aifc__cta:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.30);
}
.v2026-aifc__cta-ico {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  background-color: #ffffff;
}

/* v-select skin — the .v2026-sch-maidpick recipe from ScheduleTabV2026, copied not imported. */
.v2026-aifc__maidpick {
  font-size: var(--v2026-fs-body);
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-toggle {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  padding: var(--v2026-sp-2) var(--v2026-sp-3);
  min-height: 44px;
  background: var(--v2026-surface);
  border: 1px solid #EBEDF0;
  border-radius: var(--v2026-r-tab);
}
/* Magnifier has to be a pseudo-element: vue-select's `header` slot renders outside
   .vs__dropdown-toggle. Decorative only. */
.v2026-aifc__maidpick ::v-deep .vs__dropdown-toggle::before {
  content: "\f002";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  flex: 0 0 auto;
  font-size: 14px;
  line-height: 1;
  color: var(--v2026-text-secondary);
  pointer-events: none;
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-toggle:focus-within {
  border-color: var(--v2026-color-main);
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
/* `vs--open` lands on the v-select ROOT, the same node carrying .v2026-aifc__maidpick.
   MUST stay after :focus-within: identical specificity, so source order decides. */
.v2026-aifc__maidpick.vs--open ::v-deep .vs__dropdown-toggle {
  border-color: var(--v2026-color-main);
  border-bottom-color: transparent;
  border-radius: var(--v2026-r-tab) var(--v2026-r-tab) 0 0;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
.v2026-aifc__maidpick ::v-deep .vs__selected-options {
  padding: 0;
  min-width: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}
.v2026-aifc__maidpick ::v-deep .vs__search,
.v2026-aifc__maidpick ::v-deep .vs__search:focus {
  margin: 0;
  padding: 0;
  color: var(--v2026-text);
  font-size: var(--v2026-fs-body);
}
.v2026-aifc__maidpick ::v-deep .vs__search::placeholder {
  color: var(--v2026-text-secondary);
  opacity: 1;
}
.v2026-aifc__maidpick ::v-deep .vs__selected {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  margin: 0;
  padding: 0;
  background-color: transparent;
  border-color: transparent;
  color: var(--v2026-text);
  font-size: var(--v2026-fs-body);
}
.v2026-aifc__maidpick ::v-deep .vs__actions {
  padding: 0;
  color: var(--v2026-icon);
}
.v2026-aifc__maidpick ::v-deep .vs__open-indicator,
.v2026-aifc__maidpick ::v-deep .vs__clear {
  fill: var(--v2026-icon);
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-menu {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-1);
  padding: var(--v2026-sp-2);
  max-height: 260px;
  overflow-y: auto;
  background: var(--v2026-surface);
  border: 1px solid var(--v2026-color-main);
  border-top-color: transparent;
  border-radius: 0 0 var(--v2026-r-tab) var(--v2026-r-tab);
  box-shadow: 0 6px 14px 0 rgba(0, 0, 0, 0.16);
  z-index: 1000;
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-menu::-webkit-scrollbar {
  width: 6px;
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-menu::-webkit-scrollbar-thumb {
  background: var(--v2026-color-main);
  border-radius: 3px;
}
/* display:flex is required — vue-select ships display:block. */
.v2026-aifc__maidpick ::v-deep .vs__dropdown-option {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  padding: var(--v2026-sp-2) var(--v2026-sp-3);
  border-radius: var(--v2026-r-box);
  background: var(--v2026-surface);
  color: var(--v2026-text);
  font-size: var(--v2026-fs-section);
  line-height: 1.45;
  white-space: nowrap;
  cursor: pointer;
}
/* !important is MANDATORY: assets/beneat.scss sets the background !important and leaves
   vue-select's white text behind it — the invisible row. Do not remove. */
.v2026-aifc__maidpick ::v-deep .vs__dropdown-option--highlight {
  background: var(--v2026-surface-hover) !important;
  color: var(--v2026-text);
  box-shadow: inset 0 0 0 1px var(--v2026-color-main);
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-option--highlight .v2026-aifc__maidpick-id {
  color: var(--v2026-icon);
}
.v2026-aifc__maidpick ::v-deep .vs__dropdown-option--selected {
  background: var(--v2026-color-main-soft);
}
.v2026-aifc__maidpick ::v-deep .vs__no-options {
  padding: var(--v2026-sp-3);
  text-align: center;
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-secondary);
}
/* Slot content is compiled in this component's scope, so no ::v-deep below. */
.v2026-aifc__maidpick-id {
  flex: 0 0 auto;
  color: var(--v2026-text-secondary);
  font-weight: 400;
}
.v2026-aifc__maidpick-name {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--v2026-text);
  font-weight: 600;
}
</style>
